import { useQuery } from '@tanstack/react-query';
import { MIN_SEARCH_LENGTH } from '@/consts/search-const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GlobalSearchApiResponse } from '@/types/globalSearchApiTypes';
import {
  FILTER_DIRECTORY_QUERY_KEY,
  FILTER_PARTNERS_QUERY_KEY,
  SEARCH_QUERY_CATEGORY_KEY,
  SEARCH_QUERY_KEY,
} from '../../consts/search-const';
import { getGlobalSearchQueryUrl } from '../../utils/getGlobalSearchQueryUrl';

export const useGlobalSearchQuery = () => {
  const [searchParams] = useSearchQuery();
  const search = searchParams.get(SEARCH_QUERY_KEY);
  const category = searchParams.getAll(SEARCH_QUERY_CATEGORY_KEY);
  const partners = searchParams.getAll(FILTER_PARTNERS_QUERY_KEY);
  const directory = searchParams.getAll(FILTER_DIRECTORY_QUERY_KEY);
  const url = getGlobalSearchQueryUrl({
    search,
    category,
    partners,
    directory,
  });

  const { doFetch } = useFetch<void, GlobalSearchApiResponse>();
  const { data, isLoading, isError } = useQuery({
    queryKey: ['global-search', url],
    queryFn: () => doFetch(url),
    enabled: !!search?.length && search.length >= MIN_SEARCH_LENGTH,
  });

  return {
    isLoading,
    isError,
    data,
  };
};
